import React, { useEffect, useState, useContext } from 'react';
import { ICategory } from '@pwskills/rachnaui/components/Navbar/Navbar.types';
import HomePageApi from '@/api/homePage';
import { IError } from '@/interfaces/common';
import { useRouter } from 'next/router';
import moEvent from '@/utils/moEngage';
import { LeadCaptureEnquiryType, ModalType } from '@/interfaces/leadCapture.enum';
import BaseLayout from '../common/BaseLayout';
import ChooseProgram from './ChooseProgram';
import KeyBenfits from './KeyBenefits';
import CategoryHighlights from './CategoryHighlights';
import FreeOfferings from './FreeOfferings';
import LearnersCommunity from './LearnersCommunity';
import MentorsSection from './MentorsSection';
import FeaturedInNews from './FeaturedInNews';
import ProudAlumni from './ProudAlumni';
import SuccessStories from './SucessStories';
import Testimonial from './Testimonials';
import CategoryPageContext from '../../context/CategoryPageContext';
import SEOSection from './SEOSection';
import Faq from './FAQs';
// import CounsellorConnectStrip from '../common/LeadCaptureUI/CounsellorConnectStrip';
import useUserDetails from '../../store/userDetails';
import { getNavigationContext } from '../../utils/navigationContext';
import Hero from './HeroSection/Hero';
import LeadFormModal2 from '../common/LeadForm/LeadFormModal2';
// import { phoneNumber } from '../CourseDescriptionPageProfessional/CourseCurriculum/constants';

const CategoryDescriptionPage = ({ categoryId }: { categoryId: string }) => {
  const [categoryData, setCategoryData] = useState<ICategory[]>([]);
  const { categoryDetails } = useContext(CategoryPageContext);
  // const { user } = useContext(UserDetailsContext);
  const { userDetails: user } = useUserDetails();

  const router = useRouter();
  const navigationContext = getNavigationContext(router.asPath);

  const fetchCompanyAndFaqsDetails = async () => {
    try {
      const catchResponse = await HomePageApi.getCompanyAndFaqs();

      if (catchResponse) {
        const categoriesDetails = catchResponse?.data?.categories;
        setCategoryData(categoriesDetails);
      }
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
    }
  };

  useEffect(() => {
    if (user?._id && categoryDetails && router?.isReady) {
      const moEventData = {
        user_id: user?._id || '',
        phone_number: user?.phoneNumber || '',
        user_type: user?._id ? 'loggedin' : 'not_loggedin',
        category_name: categoryDetails?.categoryDetails?.name || '',
        category_id: categoryDetails?.categoryDetails?._id || '',
        category_slug: categoryDetails?.categoryDetails?.slug || '',
        source_URL: router?.query?.source || navigationContext.source || '',
        source_position: router?.query?.position || navigationContext.position || '',
        ...(user?.verified && user?.email && { email: user.email }),
      };
      moEvent('category_page_view', moEventData);
    }
  }, [router?.isReady, user, categoryDetails]);

  useEffect(() => {
    fetchCompanyAndFaqsDetails();
  }, []);

  return (
    <div className="relative">
      <BaseLayout category={categoryData} updateColor pageName="category_page" isProfessionalTheme>
        <Hero />
        <ChooseProgram categoryId={categoryId} />
        {categoryDetails?.enableCategoryFeature && <KeyBenfits />}
        {categoryDetails?.enableMentor && <MentorsSection />}
        {categoryDetails?.enableAboutCategory && <CategoryHighlights />}
        {categoryDetails?.enableAlumni && <ProudAlumni />}
        {categoryDetails?.enableSuccessStories && <SuccessStories />}
        {categoryDetails?.enableCommunity && <LearnersCommunity />}
        {categoryDetails?.enableTestimonials && <Testimonial />}
        <FreeOfferings categoryId={categoryId} />
        {/* <CounsellorConnectStrip phoneNumber={phoneNumber} pageName="category_page" /> */}
        {categoryDetails?.enableNews && <FeaturedInNews />}
        {categoryDetails?.enableSeoSection && <SEOSection />}
        {categoryDetails?.enableFaq && <Faq />}
        <LeadFormModal2
          buttonText="Next"
          enquiryTypeNPF={LeadCaptureEnquiryType.CATEGORY_PAGE_LEADFORM}
          modalType={ModalType.CATEGORY_PAGE_FORM}
          pageName="category_page"
        />
      </BaseLayout>
    </div>
  );
};

export default CategoryDescriptionPage;
